<div
  class="bai-qrow"
  [class.bai-qrow--selected]="selected()"
  [class.bai-qrow--collapsed]="collapsed()"
  [ngClass]="bucketClass()"
  (click)="onSelect()"
  [attr.aria-selected]="selected()"
  role="option"
  tabindex="0"
  (keydown.enter)="onSelect()"
  (keydown.space)="onSelect()"
>

  <!-- Avatar + presence dot -->
  <div class="bai-qrow__avatar-wrap">
    <p-avatar
      [label]="initials()"
      shape="circle"
      [styleClass]="'bai-qrow__avatar' + (selected() ? ' bai-qrow__avatar--selected' : '')"
      [pTooltip]="collapsed() ? avatarTooltip() : undefined"
      tooltipPosition="right"
    />
    <span
      class="bai-qrow__presence"
      [class]="presenceClass()"
      [pTooltip]="presenceLabel()"
      tooltipPosition="right"
      aria-hidden="true"
    ></span>
  </div>

  @if (!collapsed()) {
    <!-- Main content -->
    <div class="bai-qrow__body">

      <!-- Row 1: name + kebab -->
      <div class="bai-qrow__name-row">
        <span class="bai-qrow__name">
          {{ row().session.subjectData.firstName | capitalizeFirst }}
          {{ row().session.subjectData.lastName | capitalizeFirst }}
        </span>
        <div class="bai-qrow__actions-wrap" (click)="$event.stopPropagation(); $any($event.target).closest('[class*=__action]') && $any($event.currentTarget).removeAttribute('open')">
          <!-- Rank reason tooltip trigger -->
          <button
            type="button"
            class="bai-qrow__icon-btn"
            [pTooltip]="rankTooltip()"
            tooltipPosition="left"
            [tooltipStyleClass]="'bai-qrow__rank-tooltip'"
            aria-label="Why is this client here?"
          >
            <i class="pi pi-info-circle"></i>
          </button>
          <!-- Kebab menu -->
          <div class="bai-qrow__kebab-wrap">
            <button
              type="button"
              class="bai-qrow__icon-btn"
              (click)="toggleMenu($event)"
              [attr.aria-expanded]="menuOpen()"
              aria-haspopup="true"
              aria-label="Quick actions"
            >
              <i class="pi pi-bars"></i>
            </button>
            @if (menuOpen()) {
              <div
                class="bai-qrow__menu"
                role="menu"
                aria-label="Quick actions"
              >
                <button
                  type="button"
                  class="bai-qrow__menu-item"
                  role="menuitem"
                  (click)="onAction('open_chat', $event)"
                >
                  <i class="pi pi-comments"></i> Open chat
                </button>
                <button
                  type="button"
                  class="bai-qrow__menu-item"
                  role="menuitem"
                  (click)="onAction('assign_to_me', $event)"
                >
                  <i class="pi pi-user-plus"></i> Assign to me
                </button>
                <button
                  type="button"
                  class="bai-qrow__menu-item"
                  role="menuitem"
                  (click)="onAction('call_client', $event)"
                >
                  <i class="pi pi-phone"></i> Call client
                </button>
                <button
                  type="button"
                  class="bai-qrow__menu-item"
                  role="menuitem"
                  (click)="onAction('email_client', $event)"
                >
                  <i class="pi pi-envelope"></i> Email client
                </button>
                <button
                  type="button"
                  class="bai-qrow__menu-item"
                  role="menuitem"
                  (click)="onAction('snooze', $event)"
                >
                  <i class="pi pi-clock"></i> Snooze 15m
                </button>
                <button
                  type="button"
                  class="bai-qrow__menu-item bai-qrow__menu-item--danger"
                  role="menuitem"
                  (click)="onAction('archive', $event)"
                >
                  <i class="pi pi-inbox"></i> Archive
                </button>
              </div>
            }
          </div>
        </div>
      </div>

    
        <div class="client-company truncate">
          Company: {{ row().session.subjectData.company | capitalizeFirst }}
        </div>
  

      <!-- Row 2: presence + channel -->
      <!-- <div class="bai-qrow__meta-row">
        <span class="bai-qrow__presence-text">{{ presenceLabel() }}</span>
        <span class="bai-qrow__sep" aria-hidden="true">·</span>
        <span class="bai-qrow__channel">
          <i [class]="channelIcon()"></i>
          {{ channelLabel() }} · {{ row().lastChannelMinutesAgo }}m ago
        </span>
      </div> -->

      <!-- Row 3: wait + badges -->
      <!-- <div class="bai-qrow__badge-row">
        <span class="bai-qrow__wait">{{ waitLabel() }}</span>
        <span
          class="bai-qrow__badge"
          [class]="urgencyClass()"
        >{{ urgencyLabel() }}</span>
        @if (handoffLabel()) {
          <span
            class="bai-qrow__badge"
            [class]="handoffClass()"
          >{{ handoffLabel() }}</span>
        }
        @if (row().hasUpcomingCall) {
          <span
            class="bai-qrow__badge bai-qrow__badge--call"
            pTooltip="Upcoming call scheduled"
            tooltipPosition="top"
          >
            <i class="pi pi-phone"></i> Call
          </span>
        }
        @if (qualityRisk() !== 'none') {
          <span
            class="bai-qrow__badge bai-qrow__quality-badge"
            [ngClass]="qualityRiskClass()"
            [pTooltip]="qualityRiskTooltip()"
            tooltipPosition="top"
            [attr.aria-label]="qualityRiskTooltip()"
          >
            <i class="pi pi-star-fill" aria-hidden="true"></i>
            {{ qualityRiskLabel() }}
          </span>
        }
      </div> -->

    </div>
  }

</div>
